import { useMemo } from 'react';
import { useQuantifyStore } from '../store/quantifyStore';

export const useGetQuantifyMetadataV2 = () => {
  const compareFilterAName = useQuantifyStore(
    ({ query }) => query.compareMetadata?.baseQueryName,
  );
  const compareFilterBName = useQuantifyStore(
    ({ query }) => query.compareMetadata?.deltaQueryName,
  );

  const visualisationType = useQuantifyStore(
    ({ query }) => query.visualisationType,
  );

  return useMemo(
    () => ({
      compareMetadata: {
        baseQueryName: compareFilterAName,
        deltaQueryName: compareFilterBName,
      },
      visualisationType: visualisationType,
    }),
    [compareFilterAName, compareFilterBName, visualisationType],
  );
};
